import { sceneManager, license, setIsActive } from ".."
import { closeAllMenus } from "./Menus"
import { openSaveScenePopup } from "./SaveManager"
import { connected } from "./Helpers"
import { showMessage } from "../Message"

const NON_TYPING_INPUTS = ["range", "color", "checkbox", "radio", "button", "submit"]

// True while the user is typing in a text field, so shortcuts don't steal keystrokes
const isTyping = () => {
	const el = document.activeElement
	// A field inside a closed popup can keep focus, so ignore hidden fields
	if (!el || el.offsetParent === null) return false
	if (el.isContentEditable || el.tagName == "TEXTAREA" || el.tagName == "SELECT") return true
	return el.tagName == "INPUT" && !NON_TYPING_INPUTS.includes(el.type)
}

const selectedSubject = () => {
	const subject = sceneManager.selectedManager.subject
	return subject && subject.alive ? subject : null
}

// Click the subject's tab button so the tab icons stay in sync with the state
const clickTabButton = (subject, action) => {
	const tab = document.getElementById(subject.id)
	const button = tab && tab.querySelector(`[data-shortcut="${action}"]`)
	if (button) button.click()
}

const deselectAll = () => {
	const subject = sceneManager.selectedManager.subject
	if (subject) subject.deselect()
	sceneManager.directionalLight.deselect()
	sceneManager.gizmo.detach()
}

const openSaveScene = () => {
	if (!license.valid) return license.check()
	if (!connected) {
		showMessage("Internet connection required for cloud features", 4000, 300)
		return
	}
	closeAllMenus()
	openSaveScenePopup()
	document.querySelector("#scene-name").focus()
}

export const toggleShortcutsPopup = () => {
	const popup = document.querySelector("#shortcuts-popup")
	if (popup.classList.contains("is-active")) {
		closeAllMenus()
	} else {
		closeAllMenus()
		setIsActive(popup)
	}
}

document.addEventListener("keydown", (event) => {
	if (isTyping()) {
		if (event.key == "Escape") {
			document.activeElement.blur()
			closeAllMenus()
		}
		return
	}

	const key = event.key.toLowerCase()
	const mod = event.metaKey || event.ctrlKey

	// Modifier shortcuts
	if (mod && !event.altKey) {
		if (key == "z" && event.shiftKey) {
			event.preventDefault()
			sceneManager.stateManager.redo()
		} else if (key == "z") {
			event.preventDefault()
			sceneManager.stateManager.undo()
		} else if (key == "y" && !event.shiftKey) {
			event.preventDefault()
			sceneManager.stateManager.redo()
		} else if (key == "s" && !event.shiftKey) {
			event.preventDefault()
			openSaveScene()
		}
		return
	}
	if (event.altKey || event.metaKey || event.ctrlKey) return

	if (event.key == "?") {
		toggleShortcutsPopup()
		return
	}

	if (event.key == "Escape") {
		const character = sceneManager.selectedManager.character
		const popupOpen = document.querySelector(".popup.is-active, .popup-menu.is-active")
		if (character && character.editingHand) {
			character.exitHandEditor()
		} else if (popupOpen) {
			closeAllMenus()
		} else {
			deselectAll()
		}
		return
	}

	// Shift+C saves the camera position, C restores it
	if (key == "c") {
		if (!event.repeat) {
			if (event.shiftKey) sceneManager.saveCameraPosition()
			else sceneManager.setCameraPosition()
		}
		return
	}

	if (event.shiftKey) return

	if (event.code == "Delete" || event.code == "Backspace") {
		const subject = selectedSubject()
		if (subject) subject.delete()
		return
	}

	switch (key) {
		case "q":
			sceneManager.setGizmo("rotate")
			break
		case "w":
			sceneManager.setGizmo("translate")
			break
		case "e":
			sceneManager.setGizmo("scale")
			break
		case "r":
			sceneManager.setGizmo("hidden")
			break
		case "l":
			sceneManager.lockCamera(document.querySelector("#lock-camera"))
			break
		case "j":
			sceneManager.toggleMirrorPosingMode(document.querySelector("#mirror-posing"))
			break
		case "f":
			if (!event.repeat) sceneManager.setRotationPoint(selectedSubject())
			break
		case "p":
			if (!event.repeat) sceneManager.takeScreenshot()
			break
		case "h": {
			const subject = selectedSubject()
			if (subject) clickTabButton(subject, "hide")
			break
		}
		case "k": {
			const subject = selectedSubject()
			if (subject) clickTabButton(subject, "lock")
			break
		}
		case "g": {
			const subject = selectedSubject()
			if (subject) subject.putOnGround()
			break
		}
		case "m": {
			const subject = selectedSubject()
			if (subject) subject.flip()
			break
		}
	}
})
